import {
  createOrganization,
  createTank,
  createTrip,
  createTripCargo,
  createVessel,
  createVesselParticulars,
  createVoyage,
} from "../../../domain/entities";
import { ENTITY_TYPES } from "../../../domain/constants/entityTypes";

export const createFoundationUseCases = ({ localDataAccess }) => {
  const { repositories, coordinators } = localDataAccess;

  return {
    async createOrganization(input, meta) {
      const entity = createOrganization(input);
      return coordinators.atomicOperationalWrite.commitEntityWrite({
        entity,
        entityType: ENTITY_TYPES.ORGANIZATION,
        entityRepository: repositories.organizations,
        operation: "create",
        actorId: meta.actorId,
        summary: `Created organization ${entity.name}`,
        payload: { organizationId: entity.id },
        scope: {
          organizationId: entity.id,
          vesselId: meta.vesselId || "global",
        },
      });
    },

    async createVessel(input, meta) {
      const entity = createVessel(input);
      return coordinators.atomicOperationalWrite.commitEntityWrite({
        entity,
        entityType: ENTITY_TYPES.VESSEL,
        entityRepository: repositories.vessels,
        operation: "create",
        actorId: meta.actorId,
        summary: `Created vessel ${entity.name}`,
        payload: { vesselId: entity.id },
        scope: {
          organizationId: entity.organizationId,
          vesselId: entity.id,
        },
      });
    },

    async saveVesselParticulars(input, meta) {
      const entity = createVesselParticulars(input);
      return coordinators.atomicOperationalWrite.commitEntityWrite({
        entity,
        entityType: ENTITY_TYPES.VESSEL_PARTICULARS,
        entityRepository: repositories.vesselParticulars,
        operation: "update",
        actorId: meta.actorId,
        summary: `Saved particulars for vessel ${entity.vesselId}`,
        payload: { vesselId: entity.vesselId },
        scope: {
          organizationId: meta.organizationId,
          vesselId: entity.vesselId,
        },
      });
    },

    async createTank(input, meta) {
      const entity = createTank(input);
      return coordinators.atomicOperationalWrite.commitEntityWrite({
        entity,
        entityType: ENTITY_TYPES.TANK,
        entityRepository: repositories.tanks,
        operation: "create",
        actorId: meta.actorId,
        summary: `Created tank ${entity.name}`,
        payload: { tankId: entity.id },
        scope: {
          organizationId: meta.organizationId,
          vesselId: entity.vesselId,
        },
      });
    },

    async createVoyage(input, meta) {
      const entity = createVoyage(input);
      return coordinators.atomicOperationalWrite.commitEntityWrite({
        entity,
        entityType: ENTITY_TYPES.VOYAGE,
        entityRepository: repositories.voyages,
        operation: "create",
        actorId: meta.actorId,
        summary: `Created voyage ${entity.voyageNumber}`,
        payload: { voyageId: entity.id },
        scope: {
          organizationId: entity.organizationId,
          vesselId: entity.vesselId,
          voyageId: entity.id,
        },
      });
    },

    async createTrip(input, meta) {
      const entity = createTrip(input);
      return coordinators.atomicOperationalWrite.commitEntityWrite({
        entity,
        entityType: ENTITY_TYPES.TRIP,
        entityRepository: repositories.trips,
        operation: "create",
        actorId: meta.actorId,
        summary: `Created trip sequence ${entity.sequence}`,
        payload: { tripId: entity.id },
        scope: {
          organizationId: meta.organizationId,
          vesselId: meta.vesselId,
          voyageId: entity.voyageId,
          tripId: entity.id,
        },
      });
    },

    async createTripCargo(input, meta) {
      const entity = createTripCargo(input);
      return coordinators.atomicOperationalWrite.commitEntityWrite({
        entity,
        entityType: ENTITY_TYPES.TRIP_CARGO,
        entityRepository: repositories.tripCargo,
        operation: "create",
        actorId: meta.actorId,
        summary: `Created cargo ${entity.productName}`,
        payload: { tripCargoId: entity.id },
        scope: {
          organizationId: meta.organizationId,
          vesselId: meta.vesselId,
          voyageId: meta.voyageId,
          tripId: entity.tripId,
        },
      });
    },
  };
};
